import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import * as ac from "../../actions/entity";

import type { BenchmarkEntityState } from "./types";

const initialState = {
    selectedBenchmark: undefined,
    isLoading: false,
    benchmarks: undefined,
    isBenchmarkFetched: false,
    error: null,
};

const benchmarkEntityReducer = createReducer<BenchmarkEntityState, ActionType<typeof ac>>(initialState)
    .handleAction(
        ac.setSelectedBenchmark,
        (state, { payload }): BenchmarkEntityState => ({
            ...state,
            selectedBenchmark: payload,
        }),
    )
    .handleAction(
        ac.getBenchmark.failure,
        (state): BenchmarkEntityState => ({
            ...state,
            isLoading: false,
        }),
    )
    .handleAction(
        ac.getBenchmark.request,
        (state): BenchmarkEntityState => ({
            ...state,
            selectedBenchmark: undefined,
            isLoading: true,
        }),
    )
    .handleAction(
        ac.getBenchmark.success,
        (state, { payload }): BenchmarkEntityState => ({
            ...state,
            selectedBenchmark: payload,
            isLoading: false,
            isBenchmarkFetched: true,
        }),
    );
export default benchmarkEntityReducer;
